import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import TravelForm, {TravelFormProps} from "../../../pages/consumers/travel/components/TravelForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, TravelFormProps {
}

type Props = OwnProps;

// @ts-ignore
const TravelModal = NiceModal.create<Props>(({travel, header, onClose }) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <TravelForm travel={travel}/>
        </SlideOver>
    )
})

export default TravelModal;
